import { Route } from 'components/dynamic-page/route-matchers/types';
import { HeadDataType } from 'components/head-data';
import { SEOConfig } from '@tenants/types';

/**
 * Applies tenant-specific SEO rules to head tags
 *
 * @param headTags The original head tags
 * @param routeName The current route name
 * @param seoConfig The tenant's SEO configuration
 * @returns Updated head tags with tenant-specific SEO settings
 */
export function applySeoRules(headTags: HeadDataType, routeName: Route, seoConfig?: SEOConfig): HeadDataType {
  if (!seoConfig) {
    return headTags;
  }

  const updatedHeadTags = { ...headTags };

  // Apply noIndex rule for matching route
  if (seoConfig.noIndexRoutes?.includes(routeName)) {
    updatedHeadTags.noIndex = true;
  }

  // Apply noFollow rule for matching route
  if (seoConfig.noFollowRoutes?.includes(routeName)) {
    updatedHeadTags.noFollow = true;
  }

  return updatedHeadTags;
}